export const vimovaTheme = {
  colors: {
    primary: '#412645', // Aubergine
    primaryLight: '#5a3d5e',
    orange: '#ef713f',
    green: '#a5cc74',
    greenDark: '#76994a',
    white: '#ffffff',
    text: '#333333',
    textDark: '#1a1a1a',
    textLight: '#746b56',
    textMuted: '#929292',
    warmGray: '#b4af9b',
    border: '#eee9e0',
    borderLight: '#f5f0e8',
    background: '#ffffff',
    backgroundWarm: '#fcfaf5',
    backgroundLight: '#f9f9f9',
    backgroundMuted: '#eee9e0',
    danger: '#dc3545',
  },
  fonts: {
    heading: "'Outfit', sans-serif",
    body: "'Outfit', sans-serif",
  },
  fontSizes: {
    micro: '9px',
    small: '11px',
    body: '13px',
    medium: '14px',
    large: '18px',
    xlarge: '22px',
    huge: '32px',
    title: '36px',
  },
  fontWeights: {
    normal: 400,
    bold: 700,
    black: 900,
  },
  spacing: {
    pageMargin: '20mm',
    sectionGap: '24px',
    contentGap: '16px',
    smallGap: '8px',
    tinyGap: '4px',
  },
  borderRadius: {
    signature: '0 0 30px 0',
    signatureLarge: '0 0 64px 0',
    small: '4px',
    medium: '8px',
  },
  shadows: {
    card: 'rgba(0,0,0,0.1) 0 32px 64px -12px',
    small: '0 2px 8px rgba(0,0,0,0.06)',
  },
  print: {
    pageSize: 'A4',
    pageWidth: '210mm',
    pageHeight: '297mm',
  },
}

export type VimovaTheme = typeof vimovaTheme
